import { useState, useCallback } from 'react';

export const useModal = () => {
  const [modal, setModal] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'info',
    confirmText: 'Aceptar',
    cancelText: 'Cancelar',
    onConfirm: null,
    onCancel: null,
    showCancel: false
  });

  const showAlert = useCallback((title, message, type = 'info', confirmText = 'Aceptar') => {
    return new Promise((resolve) => {
      setModal({
        isOpen: true,
        title,
        message,
        type,
        confirmText,
        cancelText: 'Cancelar',
        onConfirm: () => {
          setModal(prev => ({ ...prev, isOpen: false }));
          resolve(true);
        },
        onCancel: () => {
          setModal(prev => ({ ...prev, isOpen: false }));
          resolve(false);
        },
        showCancel: false
      });
    });
  }, []);

  const showConfirm = useCallback((title, message, confirmText = 'Aceptar', cancelText = 'Cancelar') => {
    return new Promise((resolve) => {
      setModal({
        isOpen: true,
        title,
        message,
        type: 'confirm',
        confirmText,
        cancelText,
        onConfirm: () => {
          setModal(prev => ({ ...prev, isOpen: false }));
          resolve(true);
        },
        onCancel: () => {
          setModal(prev => ({ ...prev, isOpen: false }));
          resolve(false);
        },
        showCancel: true
      });
    });
  }, []);

  const showSuccess = useCallback((title, message, confirmText = 'Genial!') => {
    return showAlert(title, message, 'success', confirmText);
  }, [showAlert]);

  const showError = useCallback((title, message, confirmText = 'Entendido') => {
    return showAlert(title, message, 'error', confirmText);
  }, [showAlert]);

  const showWarning = useCallback((title, message, confirmText = 'Entendido') => {
    return showAlert(title, message, 'warning', confirmText);
  }, [showAlert]);

  const closeModal = useCallback(() => {
    setModal(prev => ({ ...prev, isOpen: false }));
  }, []);

  return {
    modal,
    showAlert,
    showConfirm,
    showSuccess,
    showError,
    showWarning,
    closeModal
  };
};